console.log('Updated:', 'Mon Aug  5 16:30:03 PDT 2024')
import '@fontsource-variable/inter';
import './styles.scss';
import yaml from 'js-yaml';
import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import Dashboard from './components/Dashboard';
import Featured from './components/Featured';

const root = createRoot(
  document.querySelector('#app') as Element | DocumentFragment,
);

const Loader = () => {
  const [content, setContent] = useState();

  useEffect(() => {
    fetch('/content.yml')
      .then((response) => response.text())
      .then((text) => yaml.load(text))
      .then((data) => setContent(data))
      .catch((error) => console.error('Error loading content.yml:', error));
  }, []);

  if (!content) {
    return <></>;
  }

  const router = createBrowserRouter([
    {
      path: '/',
      element: <Featured content={content as Content} />,
    },
    {
      path: 'dashboard',
      element: <Dashboard content={content as Content} />,
      children: [
        {
          path: ':projectTitle',
          element: <Dashboard content={content as Content} />,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};

root.render(<Loader />);
